import { render, staticRenderFns } from "./FormContactGeneral.vue?vue&type=template&id=2bbc12a1&"
import script from "./FormContactGeneral.vue?vue&type=script&lang=ts&"
export * from "./FormContactGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbc12a1')) {
      api.createRecord('2bbc12a1', component.options)
    } else {
      api.reload('2bbc12a1', component.options)
    }
    module.hot.accept("./FormContactGeneral.vue?vue&type=template&id=2bbc12a1&", function () {
      api.rerender('2bbc12a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/FormContactGeneral.vue"
export default component.exports